import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StoreRow = ({ store, index }) => {
  return (
    <Styles.Container>
      <Styles.IndexContainer>
        <Text type="bodyMRegular">{index}</Text>
      </Styles.IndexContainer>
      <td>
        <Styles.FlagAndNameContainer>
          <Text type="titleS">{store?.store_name}</Text>
        </Styles.FlagAndNameContainer>
      </td>
      <Styles.AmountsContainer>
        <Text type="bodyMRegular">
          <FormatNumber style="decimal">{store?.sales_count}</FormatNumber>
        </Text>
      </Styles.AmountsContainer>
      <Styles.AmountsContainer>
        <Text type="bodyMRegular">
          <FormatNumber style="decimal">{store?.returns_count}</FormatNumber>
        </Text>
      </Styles.AmountsContainer>
      <Styles.AmountsContainer>
        <Text type="bodyMRegular">
          <FormatNumber style="percent">{store?.returns_percentage}</FormatNumber>
        </Text>
      </Styles.AmountsContainer>
    </Styles.Container>
  )
}

export default StoreRow
